import type { SystemStep } from "../../types";
import type { FormProps } from "../webhook-form";
import { NotifyTeamForm } from "./notify-team-form";
import { AssignLeadOwnerForm, RouteHandoffForm, SendToEndpointsForm } from "./routing-forms";

/** The form for a step of a default workflow (notify, route, assign the owner, send to the endpoints). */
export function SystemStepForm({ step, disabled, onChange }: FormProps<SystemStep>) {
  switch (step.type) {
    case "notify_team":
      return <NotifyTeamForm step={step} disabled={disabled} onChange={onChange} />;
    case "route_handoff":
      return <RouteHandoffForm step={step} disabled={disabled} onChange={onChange} />;
    case "assign_lead_owner":
      return <AssignLeadOwnerForm step={step} disabled={disabled} onChange={onChange} />;
    case "send_to_subscribed_endpoints":
      return <SendToEndpointsForm />;
  }
}
